<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">Custom Date</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor: pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large"></i>
                </a>
            </div>
        </div>
        <form [formGroup]="form">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-md-8 my-3">

                    <mat-form-field appearance="fill">
                        <mat-label>Choose a month and year</mat-label>
                        <input matInput [matDatepicker]="picker" placeholder="MM/YYYY" formControlName="effectivedate"
                            [max]="Maxdate" [min]="Mindate" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker startView="multi-year"
                            (monthSelected)="chosenMonthHandler($event, picker)"
                            (yearSelected)="chosenYearHandler($event)">
                        </mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

        </form>
    </div>
</div>